import React from 'react'
import {
    useParams, useNavigate
} from "react-router-dom";
import Triologo from "./../assist/triokzzlohgo.svg"
import Triorgz from './../assist/Triorgz.png'

const NavigationBar = (props) => {
    const navigate = useNavigate()
    return (
        <nav className="border-b border-gray-200 bg-white-500 dark:bg-gray-800 dark:border-gray-700" role="navigation">
            <div className="flex flex-cols max-w-screen-xl flex flex-wrap items-center justify-between mx-auto p-1">
                <div className="flex items-center ">
                    <img src={Triologo} className="h-16" alt="Triokzz Online Shopping and Online Supermarket in India" onClick={() => navigate('/product/all')} title="Triokzz your ecommerce brand"/>
                    {/* <span class="self-center text-2xl font-semibold whitespace-nowrap dark:text-white">Triokzz</span> */}

                <ul className="flex flex-wrap items-center  text-sm font-medium text-gray-900 sm:mb-0 dark:text-white">               
                    <li className="m-2 hover:underline md:mr-6 ">
                        <a href="/">Home</a>
                    </li>
                    <li className="m-2 hover:underline md:mr-6">
                        <a href="/privacy">
                            Privacy
                        </a>
                    </li>
                    <li className="m-2 hover:underline md:mr-6 " onClick={() => navigate("/about")}>
                        About Us
                    </li>
                    <li className="m-2 hover:underline md:mr-6 " onClick={() => navigate("/faq")}>
                        FAQ
                    </li>
                    <li className="m-2 hover:underline md:mr-6 " onClick={() => navigate("/signin/seller")}>
                        Join Us
                    </li>
                </ul>
                </div>
                {/* <div class="hidden w-full" id="navbar-hamburger">
                    <ul class="flex flex-col font-medium mt-4 rounded-lg bg-gray-50 dark:bg-gray-800 dark:border-gray-700">
                        {props && props.Grocery_Menu && props.Grocery_Menu.map((val, i) => {
                            return (
                                <li key={val.key}>
                                    <a href="#" class="block py-2 px-3 text-white bg-blue-700 rounded dark:bg-blue-600" aria-current="page">{val.value}</a>
                                </li>
                            )
                        })}
                    </ul>
                </div> */}
            </div>
        </nav>
    )
}

export default NavigationBar